import styled from 'styled-components';
import { StyledButton as Button } from '../CommonComponents/Button';

export const Title = styled.div`
  font-size: 25px;
  letter-spacing: -0.06px;
  text-align: center;
  color: #444;
  margin-bottom: 25px;
`;

export const Subtitle = styled.div`
  font-size: 14px;
  font-weight: 300;
  letter-spacing: -0.22px;
  text-align: center;
  color: #000000;
  margin-bottom: 35px;
`;

export const SubtitleAccent = styled.span`
  font-weight: bold;
  color: #0078d4;
`;

export const Table = styled.div`
  border-radius: 15px;
  font-size: 14px;
  border: solid 1px #d8d8d8;
  margin-bottom: 40px;
  color: #4a4a4a;
  letter-spacing: -0.15px;
  background: #fff;
`;

export const TableHeader = styled.div`
  letter-spacing: 1.31px;
  background: #f6f6f6;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  font-size: 12px;
  color: #000000;
`;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 10px;
`;

export const TableBody = styled.div`
  max-height: calc(100vh - 430px);
  overflow-y: auto;

  ${TableRow} + ${TableRow} {
    border-top: solid 1px #e5e5e5;
  }
`;

export const TableCell = styled.div`
  padding: 0 5px;
`;

export const ConfirmButton = styled(Button.Primary)`
  display: block;
  margin: 0 auto;
  padding: 15px 70px;
`;

const textStyle = `
  font-weight: 600;
  font-size: 14px;
`;

export const AccountOwnerCellValue = styled.div`
  ${textStyle}
`;

export const DropdownTrigger = styled(Button.Link)`
  ${Button.ChildrenWrapper} {
    ${textStyle}
  }
`;
